<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                this.$l('INDEX.log_label_search') || '业务类型/操作人搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  {{ $l('INDEX.advanced_search') || '高级搜索' }}
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="130px"
        label-position="right"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.log_label_businessType') || '业务类型'"
            >
              <el-input
                size="small"
                v-model.trim="form.businessType"
                :placeholder="
                  $l('INDEX.tips_log_label_businessType') || '请输入业务类型'
                "
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('INDEX.log_label_operationBy') || '操作人'"
            >
              <dict-select
                clearable
                size="small"
                multiple
                filterable
                v-model="form.listOperationBy"
                :placeholder="
                  $l('INDEX.tips_log_label_operationBy') || '请选择操作人'
                "
                :body="operationByParams"
                url="/sys/common/dict/userDict"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-row>
              <el-form-item
                :label="$l('INDEX.log_label_operationTime') || '操作时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.operationTimeStart"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="operationTimeStartPicker"
                    :placeholder="$l('INDEX.tips_select_time') || '请选择时间'"
                    style="width: 100%"
                    size="small"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.operationTimeEnd"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="operationTimeEndPicker"
                    :placeholder="$l('INDEX.tips_select_time') || '请选择时间'"
                    style="width: 100%"
                    size="small"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = { keyword: '' }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      operationByParams: {},
      //修改日期限制
      operationTimeStartPicker: this.operationTimeEnd(),
      operationTimeEndPicker: this.operationTimeStart(),
    }
  },
  created() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    operationTimeEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.operationTimeEnd) {
            return (
              new Date(self.form.operationTimeEnd).getTime() < time.getTime()
            )
          }
        },
      }
    },
    operationTimeStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.operationTimeStart) {
            return (
              new Date(self.form.operationTimeStart).getTime() -
                3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.line {
  text-align: center;
}
</style>
